export const ProductVerificationFieldLabels = {
  title: 'Title',
  description: 'Description',
  testScriptEditor: 'Test Script Editor',
  assignTask: 'Assign Task',
  taskFiles: 'Document References',
  designOutput: 'Design Output Reference',
  attachment: 'Attachments',
  components: 'Components',
  release: 'Release'
} as const;

export type ProductVerificationField = keyof typeof ProductVerificationFieldLabels;

export const ProductVerificationFields: ProductVerificationField[] = Object.keys(
  ProductVerificationFieldLabels
) as ProductVerificationField[];
